import React, { FC } from 'react'
import { Divider, Text, csx } from '@vtex/admin-ui'
import { injectIntl } from 'react-intl'

import {
  ProductContents,
  ProductInformationItemContents,
} from './ProductInformation'
import PageModal from '../PageModal'

type ProductInformationPageProps = {
  titleId: string
  contents: ProductInformationItemContents
  isOpen: boolean
  type: string
  setIsOpen: (isOpen: boolean) => void
}

const ProductInformationPage: FC<ProductInformationPageProps> = ({
  titleId,
  contents,
  isOpen,
  type,
  setIsOpen,
}) => {
  const renderProductInformation = () => {
    if (type === 'text') {
      return (
        <div
          className={csx({
            flex: '1 1 auto',
            flexDirection: 'column',
            paddingBottom: '.75rem',
            paddingTop: '.75rem',
            marginLeft: '.75rem',
          })}
          data-testid={`page-contents-${titleId}`}
        >
          <Text
            dangerouslySetInnerHTML={{
              __html: contents as string,
            }}
          />
        </div>
      )
    }
    return (
      <div
        className={csx({
          flex: '1 1 auto',
          flexDirection: 'column',
          paddingBottom: '.75rem',
          paddingTop: '.75rem',
          marginLeft: '.75rem',
        })}
        data-testid={`page-contents-${titleId}`}
      >
        {(contents as ProductContents[]).map((item: ProductContents) => {
          return (
            <div key={item.name}>
              <div
                className={csx({ paddingTop: '1rem', paddingBottom: '1rem' })}
              >
                <Text>{item.name}</Text>
                {item.values.map((specification: string) => {
                  return (
                    <div key={specification}>
                      <Text
                        dangerouslySetInnerHTML={{ __html: specification }}
                      />
                    </div>
                  )
                })}
              </div>
              <Divider />
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <PageModal
      // TODO: this error popped up when moving the checkout-instore project
      // to checkout-instore-legacy, but needs to be fixed at some point
      // @ts-ignore
      titleId={titleId}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      children={renderProductInformation()}
    />
  )
}

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
export default injectIntl(ProductInformationPage)
